interface MarkerProps {
    text?: string
    primaryColor?: string;
    secondaryColor?: string;
}

export const VisitorMarker = ({
    text,
    primaryColor = "#00d492",
}: MarkerProps) => {

    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            className="user-marker-circle"
        >
            {/* White background circle (entire marker) */}
            <circle
                cx="16"
                cy="16"
                r="10"
                fill="white"
            />

            {/* Pulsing green circle */}
            <circle
                cx="16"
                cy="16"
                r="9"
                fill={primaryColor}
            >
                <animate
                    attributeName="r"
                    values="8;6;8"
                    dur="3.5s"
                    repeatCount="indefinite"
                />
            </circle>

            {text && (
                <text
                    x="16"
                    y="19"
                    textAnchor="middle"
                    fontSize="8"
                    fontWeight="bold"
                    fill="white"
                >
                    {text}
                </text>
            )}
        </svg>
    )
}